import { render, staticRenderFns } from "./CompetitionDateTime.vue?vue&type=template&id=1d0a123d&scoped=true"
import script from "./CompetitionDateTime.vue?vue&type=script&lang=js"
export * from "./CompetitionDateTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a123d",
  null
  
)

export default component.exports